import { cn } from '@/lib/utils'
import { Loader2 } from 'lucide-react'

interface DefaultLoadingSpinnerProps {
  className?: string
  iconClassName?: string
}

const DefaultLoadingSpinner = ({
  className,
  iconClassName,
}: DefaultLoadingSpinnerProps) => {
  return (
    <div
      className={cn(
        'flex animate-fade-in items-center justify-center',
        className,
      )}
    >
      <Loader2
        strokeWidth={1}
        className={cn('size-6 animate-spin text-white', iconClassName)}
      />
    </div>
  )
}

export default DefaultLoadingSpinner
